import { render } from "./Sections2.vue?vue&type=template&id=0e867d87&scoped=true"
import script from "./Sections2.vue?vue&type=script&lang=js"
export * from "./Sections2.vue?vue&type=script&lang=js"

import "./Sections2.vue?vue&type=style&index=0&id=0e867d87&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e867d87"]])

export default __exports__